import { render } from "./total-health.vue?vue&type=template&id=45781c62"
import script from "./total-health.vue?vue&type=script&lang=js"
export * from "./total-health.vue?vue&type=script&lang=js"

import "./total-health.vue?vue&type=style&index=0&id=45781c62&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__